import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getScanOverview, ScanOverviewResponse } from 'src/services/scan/ScanService';

export const useScanOverview = (
	scanId: string,
	viewId?: string
): UseQueryResult<ScanOverviewResponse> => {
	return useQuery<ScanOverviewResponse>({
		queryKey: ['scan-overview', scanId, viewId],
		queryFn: () => getScanOverview(scanId, viewId),
		enabled: !!scanId
	});
};
